import React from 'react';
import ReactMarkdown from 'react-markdown';
import { v4 as uuid } from 'uuid';


const renderDropDownOptions = function renderDropDownOptionsList(
  itemClassName,
  list,
) {
  const handleArrowKeys = ({ target, key }) => {
    const currentElement = document.getElementById(target.id);
    const array = Array.from(currentElement.parentNode.children);
    const index = array.indexOf(currentElement);
    const next = array[index + 1];
    const previous = array[index - 1];

    if (previous && key === 'ArrowUp') {
      previous.focus();
    }
    if (next && key === 'ArrowDown') {
      next.focus();
    }
  };
  const listItems = list.map((listItemProps) => {
    const { onKeyDown, onClick, id } = listItemProps;
    const itemClassNames = [itemClassName];

    if (listItemProps.className) {
      itemClassNames.push(listItemProps.className);
    }

    return (
      <div
        role="option"
        aria-selected="false"
        tabIndex={0}
        className={itemClassNames.join(' ')}
        onKeyUp={handleArrowKeys}
        onKeyDown={onKeyDown}
        onClick={onClick}
        id={`${id}--${uuid()}`}
      >
        <ReactMarkdown
          source={listItemProps.value}
          renderers={{
            paragraph: props => <div {...props} />,
          }}
        />
      </div>
    );
  });

  return (
    listItems
  );
};

export default renderDropDownOptions;
